var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImagenMensajes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 199.8 155.6",
    style: {
      enableBackground: "new 0 0 199.8 155.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#DADADA;}\r\n\t.st1{fill:#FFFFFF;}\r\n\t.st2{fill:#878788;}\r\n\t.st3{opacity:0.1;fill:#272727;enable-background:new    ;}\r\n\t.st4{fill:#7BB929;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_21526_00000021809982657316100720000005315635946081298317_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_21526_00000047017903980416606980000001939389368268962946_",
    transform: "translate(-523 -249)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Validacion-Documentaci\\xF3n_validada_00000024688837547925388880000018379126719785008277_",
    transform: "translate(213 163.116)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2077_00000085211993472185169510000017483065428860454843_",
    transform: "translate(10)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3417_00000105411235058150371190000011241560223839470988_",
    className: "st0",
    d: "M322.8,108.7 c30.4-30.4,79.6-30.4,110,0s30.4,79.6,0,110s-79.6,30.4-110,0C292.4,188.3,292.4,139,322.8,108.7 C322.8,108.7,322.8,108.7,322.8,108.7z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_44_00000152255044985057640330000003224510764390317730_",
    className: "st0",
    cx: 377.8,
    cy: 163.7,
    r: 72.3
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2070_00000155846694682676624530000006809560282010738585_",
    transform: "translate(616.761 229.15)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2067_00000034060430350699841250000001619687987772419511_",
    transform: "translate(0 36.086)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_834_00000008834004361626060340000016991709901543584183_",
    x: -289.2,
    y: -128.2,
    className: "st1",
    width: 56.6,
    height: 74.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_835_00000168105695769039915480000007274812611823342735_",
    x: -281.5,
    y: -120.1,
    className: "st2",
    width: 41.1,
    height: 2.7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_836_00000111164278945459140150000007876390846383517371_",
    x: -281.5,
    y: -112,
    className: "st2",
    width: 41.1,
    height: 2.7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_837_00000013180926271497289900000006336504993359306634_",
    x: -281.5,
    y: -103.9,
    className: "st2",
    width: 41.1,
    height: 2.7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_838_00000050636489126466122210000015039199138197497992_",
    x: -281.5,
    y: -95.8,
    className: "st2",
    width: 41.1,
    height: 2.7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_839_00000092425496530755573440000000551888111812895902_",
    x: -281.5,
    y: -87.7,
    className: "st2",
    width: 41.1,
    height: 2.7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_840_00000057122465787957679510000003602961073065605509_",
    x: -281.5,
    y: -79.6,
    className: "st2",
    width: 41.1,
    height: 2.7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_841_00000002356938874405496430000016324140043664668601_",
    x: -281.5,
    y: -71.5,
    className: "st2",
    width: 41.1,
    height: 2.7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_842_00000119087814645695139170000001862068739277057457_",
    x: -281.5,
    y: -63.4,
    className: "st2",
    width: 27.8,
    height: 2.7
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2068_00000163073124873668208530000008293397203481663926_",
    transform: "translate(48.956 24.524)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_843_00000111885685319474523060000012124946958630470335_",
    x: -289.2,
    y: -128.2,
    className: "st1",
    width: 56.6,
    height: 74.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_844_00000102503098069252456650000007622872786910602685_",
    x: -281.5,
    y: -120.1,
    className: "st2",
    width: 41.1,
    height: 2.7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_845_00000014632961031627664520000006601509902503024787_",
    x: -281.5,
    y: -112,
    className: "st2",
    width: 41.1,
    height: 2.7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_846_00000073700204047250822790000002338557816566144642_",
    x: -281.5,
    y: -103.9,
    className: "st2",
    width: 41.1,
    height: 2.7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_847_00000130605662285946334600000015396157430486163850_",
    x: -281.5,
    y: -95.8,
    className: "st2",
    width: 41.1,
    height: 2.7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_848_00000034090784349321133280000011755528664631072411_",
    x: -281.5,
    y: -87.7,
    className: "st2",
    width: 41.1,
    height: 2.7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_849_00000074439427571853109870000016850661884371540640_",
    x: -281.5,
    y: -79.6,
    className: "st2",
    width: 41.1,
    height: 2.7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_850_00000141451934669877696470000007303522221660230784_",
    x: -281.5,
    y: -71.5,
    className: "st2",
    width: 41.1,
    height: 2.7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_851_00000156568828230118480370000004794872816274856848_",
    x: -281.5,
    y: -63.4,
    className: "st2",
    width: 27.8,
    height: 2.7
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3319_00000180349888476339478220000005002383648259393724_",
    className: "st3",
    d: "M-203.9-103.7v55.1H-269v-43.5 h28.8v-11.6H-203.9z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2069_00000044867041431188976310000015647903858700611719_",
    transform: "translate(24.427 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_852_00000061436406934193430420000000961693987240884658_",
    x: -289.2,
    y: -128.2,
    className: "st1",
    width: 56.6,
    height: 74.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_853_00000089548308499289433450000015990929974414323102_",
    x: -281.5,
    y: -120.1,
    className: "st2",
    width: 41.1,
    height: 2.7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_854_00000059999657451641710660000002719185787557871289_",
    x: -281.5,
    y: -112,
    className: "st2",
    width: 41.1,
    height: 2.7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_855_00000160160462708334556900000007004349262785639558_",
    x: -281.5,
    y: -103.9,
    className: "st2",
    width: 41.1,
    height: 2.7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_856_00000174598935826894454640000007164904549368021656_",
    x: -281.5,
    y: -95.8,
    className: "st2",
    width: 41.1,
    height: 2.7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_857_00000068664200451181311060000004381629688751643558_",
    x: -281.5,
    y: -87.7,
    className: "st2",
    width: 41.1,
    height: 2.7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_858_00000085229139503559777110000015738772855628319115_",
    x: -281.5,
    y: -79.6,
    className: "st2",
    width: 41.1,
    height: 2.7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_859_00000064354769119590858830000001126970885960741281_",
    x: -281.5,
    y: -71.5,
    className: "st2",
    width: 41.1,
    height: 2.7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_860_00000126319225882015229930000000901272841559399056_",
    x: -281.5,
    y: -63.4,
    className: "st2",
    width: 27.8,
    height: 2.7
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1907_00000044888901972924937730000017089383701376155325_",
    transform: "translate(-1160.877 -451.713)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2405_00000142862263941918282420000015085824397963240604_",
    className: "st4",
    d: "M1611.7,566.5 c-27.1,0-49,21.9-49,49s21.9,49,49,49s49-21.9,49-49C1660.6,588.4,1638.7,566.5,1611.7,566.5z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1906_00000029741142059475069540000016699718424020560018_",
    transform: "translate(1876.004 723.504)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2406_00000094599506097266224160000018107051833856000445_",
    className: "st1",
    d: "M-241.1-118.8l-29.4,29.4 c-1,1-2.4,1.6-3.9,1.6c-0.2,0-0.4,0-0.6,0c-1.7-0.2-3.2-1.1-4.1-2.6l-9.3-15c-1.6-2.6-0.8-6,1.8-7.6c2.6-1.6,5.9-0.8,7.6,1.8 l5.6,9.1l24.5-24.5c2.1-2.2,5.6-2.2,7.8-0.1c2.2,2.1,2.2,5.6,0.1,7.8C-241-118.9-241.1-118.8-241.1-118.8L-241.1-118.8z"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImagenMensajes);
export default __webpack_public_path__ + "static/media/Imagen_Mensajes.bb58b4b8df35e7da5e1d409dc544ee0e.svg";
export { ForwardRef as ReactComponent };